// Author Shi Wenlong
// Date 2021-07-10 14:39:46

import * as model from "@/model/sithMes/quality/SithMesQualityToolManageModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesQualityToolManage(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_QUALITY_URL,
    })
    .buildStore()
